import React from "react";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled, { createGlobalStyle } from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
 import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import wvBackground from "../images/wv_p4.svg"; // Adjust the path as necessary
import photo2 from '../images/animated/19.png';
const GlobalStyle = createGlobalStyle`
  body {
    background-image: url(${wvBackground}), url(${wvBackground});
    background-size: cover, cover;
    background-repeat: no-repeat, no-repeat;
    background-position: 100%, top;
    margin: 0;
    padding: 0;
    font-family: 'Inter', system-ui, sans-serif;
  }

  body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 45vh;
    background-image: url(${wvBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    transform: scaleY(-1);
    z-index: -1;
  }
`;
  
const Text = styled.div`
  ${tw`text-lg text-gray-700 leading-relaxed mx-auto bg-white rounded-3xl shadow-xl px-6 py-10 sm:px-10 md:px-16 md:py-16`}
  max-width: 52rem;
  background-color: rgba(255, 255, 255, 0.95);
  p {
    ${tw`mt-2`}
  }
  h1 {
    ${tw`text-4xl sm:text-5xl font-black text-secondary-500 leading-tight mb-6`}
  }
  h2 {
    ${tw`text-2xl sm:text-3xl font-bold text-secondary-500 mt-16 mb-4 pl-4 border-l-4 border-primary-500 leading-tight`}
    scroll-margin-top: 2rem;
  }
  h3 {
    ${tw`text-xl font-bold mt-4`}
  }
  a {
    ${tw`text-primary-500 font-semibold underline`}
  }
  ul {
    ${tw`my-6 rounded-2xl px-6 py-4 list-none`}
    background-color: #FAF6F3;
    li {
      ${tw`py-3 pl-6 relative`}
      &:not(:last-child) {
        border-bottom: 1px solid #F3EBE6;
      }
      &::before {
        content: "";
        ${tw`absolute left-0 w-2 h-2 rounded-full bg-primary-500`}
        top: 1.45rem;
      }
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Privacy Policy" }) => {


  const { therapyType } = useParams();

  useEffect(() => {
    const element = document.getElementById(therapyType);
    console.log(element,therapyType)
    if (therapyType===undefined){
      window.scrollTo(0, 0);
      return;
    }
    if (element) {
      // Check if the device is a mobile device
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // Handle scrolling for mobile devices
        window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
      } else {
        // Handle scrolling for desktop browsers
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [therapyType]);

  return (<>
    <GlobalStyle />
      <Header />
    
      <Container>
        <ContentWithPaddingXl>
          {/* <HeadingRow>
            <Heading>Onderzoek</Heading>
          </HeadingRow> */}
          <Text>
          <h1>Onderzoek</h1>
          <p>Dit zijn een aantal afspraken waarin wordt getest of er sprake is van een diagnose zoals ADHD of autisme. Dit kan door middel van een interview, vragenlijsten en/of cognitieve taken. Daarnaast wordt meestal een persoon, die jou van jongs af aan kent, betrokken bij het onderzoek.</p>
          <div className="container mx-auto flex justify-center items-center">
            <div className="flex justify-center mt-10">
              <img
                src={photo2}
                alt="Onderzoek"
                style={{ display: 'block', margin: '0 auto', maxWidth: '100%' }}
              />
            </div>
          </div>

          <h2 id="adhd">ADHD</h2>
            ADHD staat voor aandachtsdeficiëntie-/hyperactiviteitsstoornis. Bij kinderen staan de hyperactiviteit en impulsiviteit vaak wat meer op de voorgrond, bij jongeren en volwassenen de problemen met aandacht, plannen en het organiseren. De klachten zijn levenslang aanwezig en zorgen ervoor dat je op meerdere levensgebieden vastloopt zoals opleiding, werk of in relaties. Het is dan belangrijk dat een diagnose wordt gesteld zodat je toegang hebt tot verschillende therapieën, hulpmiddelen, en eventueel medicatie.

            <h2 id="autisme">Autisme</h2>
            ASS staat voor een autismespectrumstoornis. Je hebt onder andere moeite met het aangaan en onderhouden van contacten, de verbale en non-verbale (zoals lichaamstaal) communicatie, en hebt moeite met het inleven in een ander. De klachten zijn levenslang aanwezig en zorgen ervoor dat je op meerdere levensgebieden vastloopt zoals opleiding, werk of in relaties. Het is dan belangrijk dat een diagnose wordt gesteld zodat je toegang hebt tot verschillende therapieën, en hulpmiddelen.
            <h2 id="tarieven">Tarieven</h2>
       
            De maximumtarieven van de zorgprestaties worden elk jaar vastgesteld door de Nederlandse Zorgautoriteit (NZa). Het tarief per consult wordt bepaald door het type consult en de duur daarvan. Voor meer informatie kunt u terecht op <a href="https://nza.nl" target="_blank" rel="noopener noreferrer">nza.nl</a>. Psychologenpraktijk BB rekent de volgende tarieven voor de meest voorkomende consulten:
           <ul>
  <li>             ADHD onderzoek (o.b.v. 90 minuten + 60 minuten heteroanamnese) €501,38*</li>
  <li>                          ASS onderzoek (o.b.v. 90 minuten + 60 minuten heteroanamnese) €501,38*</li>
</ul>
            
      
            <i>*bij meer dan 120 minuten op één dag geldt een vastgestelde toeslag psychodiagnostiek €195,65 voor de uitwerktijd van het verslag</i>

<br></br>
<br></br>


            
In 2026 heeft Psychologenpraktijk BB een contract met:

<ul>
  
  <li>a.s.r</li>
  <li>Caresq</li>
  <li>CZ</li>
  <li>DSW (incl. Stad Holland)</li>
  <li>Menzis (incl. VinkVink en AnderZorg)</li>
  <li>Salland</li>
  <li>VGZ (incl. Univé en ZEKUR)</li>
  <li>Zilveren Kruis (incl. FBTO, de Friesland en Interpolis)</li>
  <li>Zorg en Zekerheid</li>
  </ul>
  <br></br>

Voor 2027 heeft Psychologenpraktijk BB een contract met:

<ul>
  <li>a.s.r</li>
  <li>Caresq</li>
  <li>CZ</li>
  <li>DSW (incl. Stad Holland)</li>
  <li>Menzis (incl. VinkVink en AnderZorg)</li>
  <li>Salland</li>
  <li>VGZ (incl. Univé en ZEKUR)</li>
  <li>Zilveren Kruis (incl. FBTO, de Friesland en Interpolis)</li>
  <li>Zorg en Zekerheid</li>

  </ul>

            
Ben je boven de 18 jaar en heb je een verwijsbrief van de huisarts? Dan wordt de zorg 100% vergoed en de facturen direct naar jouw zorgverzekeraar verzonden. Ik werk volgens de Spelregel Planning = Realisatie.



<br></br>
<br></br>

Indien jouw zorgverzekeraar niet in het rijtje staat betekent dit dat de zorg deels vergoed wordt. Je ontvangt na elk bezoek van de praktijk een factuur met daarop de verschillende zorgprestaties. Deze factuur betaal je altijd zelf binnen 14 dagen volgens de algemene betalingsvoorwaarden van psychologenpraktijk BB. Je kunt deze factuur meteen na ontvangst al indienen bij de zorgverzekeraar.



          </Text>
        </ContentWithPaddingXl>
   

      </Container>
      <Footer />
   </>
  );
};
